import type { DeepPartial } from '@luna/utils-ts';
import { BUNDLE_ORDER_TYPE } from '@shared/payments-types';
import { AuthorizationType } from '@shared/core-types';

import type { PaymentOrders } from './PaymentOrders';

export const SK: DeepPartial<PaymentOrders> = {
    showLastModification: true,
    alwaysRedo: false,
    orderActions: {
        isPrintEnabled: false,
    },
    orderBundler: {
        config: {
            DEFAULT: [
                {
                    combination: [BUNDLE_ORDER_TYPE.OWN_FX],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.DOMESTIC, BUNDLE_ORDER_TYPE.SEPA],
                    maxSize: 10,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.INTERNATIONAL],
                    maxSize: 5,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
            ],
            [AuthorizationType.GEORGE_TOKEN]: [
                {
                    combination: [BUNDLE_ORDER_TYPE.OWN_FX],
                    maxSize: 1,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.DOMESTIC, BUNDLE_ORDER_TYPE.SEPA],
                    maxSize: 5,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
                {
                    combination: [BUNDLE_ORDER_TYPE.INTERNATIONAL],
                    maxSize: 5,
                    mixCurrenciesAllowed: false,
                    mixSenderAccountsAllowed: false,
                    mixDifferentCurrencySenderAccounts: false,
                    mixOrderAndSenderAccountCurrencyAllowed: true,
                },
            ],
        },
    },
    failedOrderStates: [
        'AGB',
        'ABG',
        'ANE',
        'BBC',
        'BCC',
        'BLA',
        'BNS',
        'BNZ',
        'CBA',
        'CBB',
        'CSA',
        'DBC',
        'DDB',
        'DDC',
        'DDL',
        'DIB',
        'ENE',
        'KAG',
        'LGR',
        'MPP',
        'NBA',
        'NGA',
        'NGD',
        'PCN',
        'RDE',
        'RST',
        'SNM',
        'STO',
        'XXX',
        'IPA',
        'IPB',
        'IPC',
        'IPD',
        'IPE',
        'BAM',
        'BAN',
        'BPA',
        'BPR',
        'EEI',
        'FRD',
        'ISA',
        'OBG',
        'RBC',
        'REC',
    ],
    waitingOrderStates: [
        'AFU',
        'AFP',
        'INB',
        'RES',
        'RFR',
        'WFC',
        'SUS',
        'COS',
        'WEA',
        'WEU',
        'WEP',
    ],
};
